// Centralized delete flow that handles role-based routing.
// - super_admin: still calls POST /delete-requests (backend executes immediately)
// - company_admin / user: creates a delete request (requires reason)

import { api } from './api';

/**
 * Submit a delete-request. Backend handles role-based behaviour:
 *  - super_admin → immediate execution
 *  - others → pending workflow
 *
 * @param {object} opts
 * @param {string} opts.entity_type
 * @param {string} opts.entity_id
 * @param {string} opts.entity_label
 * @param {string} opts.reason (required for non super_admin; backend tolerates empty for super)
 * @param {object} [opts.executor_kwargs]
 * @param {string} [opts.company_id]
 * @returns {Promise<{pending?:boolean, deleted?:boolean, immediate?:boolean, request_id?:string, status?:string}>}
 */
export async function submitDelete(opts) {
  const payload = {
    entity_type: opts.entity_type,
    entity_id: opts.entity_id,
    entity_label: opts.entity_label,
    reason: opts.reason || '',
    executor_kwargs: opts.executor_kwargs || null,
    company_id: opts.company_id || null,
  };
  const { data } = await api.post('/delete-requests/', payload);
  return data;
}

// Human-friendly entity type labels (for the dialog title)
export const ENTITY_TYPE_LABELS = {
  vendor: 'vendor',
  goldsmith: 'goldsmith',
  gold_purity: 'gold purity',
  gold_rate: 'gold rate',
  diamond_classification: 'diamond classification',
  diamond_packet: 'diamond packet',
  color_stone_classification: 'colour stone classification',
  color_stone_packet: 'colour stone packet',
  pearl_classification: 'pearl classification',
  pearl_packet: 'pearl packet',
  order: 'order',
  order_image: 'order image',
  order_requirement: 'order requirement',
  user: 'user',
  company: 'company',
};
